/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import {SchemaSpecification} from './schema.specification';
import {TSO}                 from '@/models/scenario/t.s.o';
import {TSOSpeed}            from '@/models/scenario/t.s.o.speed';

export class TSOSpeedsSchema extends SchemaSpecification {

  constructor() {

    super();

    this.multiRow = true;

    this.jsonSpec = `{
"tso_speeds": {
  "schema": {
    "fields": [
      {
        "name": "tso_id",
        "title": "TSO to which this speed restriction applies",
        "type": "integer",
        "col": 1,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "train_class_id",
        "title": "client generated id for its category",
        "type": "integer",
        "col": 2,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "bucket",
        "title": "the of the the set of speed buckets to use",
        "type": "string",
        "col": 3,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "speed",
        "title": "(miles per hour) TSO speed",
        "type": "float",
        "col": 4,
        "constraints": {
          "required": true
        }
      }
    ]
  },
  "dataType": "table",
  "data": [
  ]
}
}`;

    super.cache();
  }

  /** convert the given object to data table row(s), only properties that match field names will be created. */
  public toRow(object: any): any[] {

    const tso:  TSO   = object as TSO;
    const rows: any[] = [];

    /*
     * each TSO (slow order) implies some number of rows of speeds that tied to that TSO;
     * in addition, we currently only support two speed groups for any TSO, the freight (FRT)
     * and passenger (PSG) groups.
     *
     */

    if(tso.speeds.has('FRT')) {

      for (const [tcId, ts] of tso.speeds.get('FRT')) {

        const proxy: any = {
          tso_id:         tso._id,
          train_class_id: tcId,
          bucket:         'FRT',
          speed:          tso._frtSpeed
        };

        rows.push(super.toRow(proxy));
      }
    }

    if(tso.speeds.has('PSG')) {

      for (const [tcId, ts] of tso.speeds.get('PSG')) {

        const proxy: any = {
          tso_id:         tso._id,
          train_class_id: tcId,
          bucket:         'PSG',
          speed:          tso._psgSpeed
        };

        rows.push(super.toRow(proxy));
      }
    }

    /* now convert that */

    return rows;
  }

  /** helper to insert tso_speeds data into the slow_orders object, returns the full object, ready to be saved. */
  render(items: TSO[]): any {

    /* create the data table */

    const d = this.dataTable(items);

    /* insert */

    const w: any = this.findObject('tso_speeds', this.schemaObj);

    if (w === null) {

      this.lastError = `(render) problems finding tso_speeds section: ${this.lastError}`;

      return null;
    }

    w['data'] = d;

    /* pass back the full rendered version, this version can be given to JSON.stringify() to save to file. */

    return this.schemaObj;
  }

}
